import CreateIndexDrawer from './CreateIndexDrawer.component';

export default CreateIndexDrawer;